import React from 'react';
import Button from '@ingka/button';
import { useComponentId } from '../../../hooks/useComponentId';
import SSRIcon from '@ingka/ssr-icon';

interface SearchPanelButtonProps {
  style?: React.CSSProperties;
  className?: string;
  disabled?: boolean;
  iconPath: (prefix?: string) => React.SVGProps<SVGElement>[];
  label: string;
  onClick: () => void;
}

const SearchPanelButton = ({
  label,
  iconPath,
  disabled = false,
  ...props
}: SearchPanelButtonProps) => {
  const id = useComponentId();
  return (
    <Button
      size="small"
      iconOnly
      type="plain"
      disabled={disabled}
      id={id}
      aria-label={label}
      tabIndex={0}
      {...props}
    >
      {[<SSRIcon paths={iconPath} key={`icon-${label}`} />]}
    </Button>
  );
};

export default SearchPanelButton;
